
import Vue from 'vue';
import Button from '../Button/Button.vue';
/**
- The form will process the validation of the given components inside the slot, with the output such as:
*   - REQUIRED components with EMPTY value.
*   - Components with props ERROR === true. (if it has error but not true, it won't be in the output)
- Note: 
*   - Please do put :error in any component that needs validation.
*   - If a component is having validation (for example email) and NOT REQUIRED, it only checks whether the email is valid or not, if the value is empty, it is not considered as error because it is NOT REQUIRED.
**/
export default Vue.extend<any, any, any, any>({
  name: 'Form',
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set value
     */
    value: {
      type: Object,
      default: () => {}
    },
    /**
     * Set form action
     */
    formAction: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSubmit(e: any) {
      if (!this.formAction) {
        //if dev doesn't insert any custom action on <form :action="" /> the page won't go anywhere
        e.preventDefault();
      }
      const val = this.value;
      let errorComponents: { [key: string]: boolean } = {};
      // BASE LOGIC: the errorComponents will gather error components and empty required components along with the status. true = error
      this.$slots.default.forEach((vNode: any) => {
        let isEmpty = false;
        if (vNode.componentOptions && vNode.componentOptions.propsData && vNode.componentOptions.listeners) {
          if (vNode.data.model && vNode.componentOptions.propsData.required) {
            isEmpty = !vNode.data.model.value;
          }
          errorComponents[vNode.data.attrs.name] = vNode.componentOptions.propsData.error || isEmpty; // error / empty means true
        }
      });
      /**
       * Pass the object with empty value
       * @event validate
       * @type {function}
       */
      this.$emit('validate', errorComponents);
      /**
       * Method to submit
       * @event validate
       * @type {function}
       */
      this.$emit('submit', e);
    }
  }
});
